module.exports = __webpack_public_path__ + "static/Sapphire_Dragon_sketch-74c70ce5221c3fa49a927eee4fea5ddc.webp";